export const GET_HOLIDAYS = 'GET_HOLIDAYS'
export const GET_HOLIDAY = 'GET_HOLIDAY'
export const CREATE_HOLIDAY = 'CREATE_HOLIDAY'
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY'
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY'
